import get from 'lodash/get'
import isNil from 'lodash/isNil'

import { HistoryUpdate } from 'api/history'
import * as PoziUtils from 'api/utils'
import { SELECTOR_TYPE_RADIO } from 'drawer/tabs/layers/Layers'
import ModelUpdateLayer from 'drawer/tabs/layers/utils/ModelUpdateLayer' // Update Legacy Model
import UnSelectOtherLayersInGroup from 'drawer/tabs/layers/utils/UnSelectOtherLayersInGroup'
import PoziNotifications from 'utils/notifications'

import {
  applyAutoFilterOnLevel,
  applyAutoFilterToVisibleLayers,
  getCurrentLevel,
  setCurrentLevel
} from './autoFilterOnLevel'

// import { setLayerSelected } from 'drawer/tabs/layers/actions'

/**
 * Layer control event handler.
 * Selecting a layer from the layer control.
 * Also handles privacy dialog
 */
export default function SelectLayer (titleid) {
  // console.debug('SelectLayer', titleid)

  const app = PoziUtils.getApp()

  const layer = PoziUtils.getLayerFromTitleID(titleid)

  if (layer.selectorType === SELECTOR_TYPE_RADIO) {
    UnSelectOtherLayersInGroup(titleid, layer.groupid)
  }

  if (!layer.selected) {
    console.debug('Layer selected', titleid)

    // Currently the redux action calls SelectLayer, where it should be the other way around
    // window.store.dispatch(setLayerSelected(titleid))

    layer.selected = true

    const access = layer.localDataSource ? 'restricted' : 'public'

    PoziUtils.gtag({
      category: 'useraction',
      status: 'success',
      identifier: layer.title,
      action: 'Layer Select',
      addtionalInfo: access
    })
  }

  if (layer && layer.localDataSource) {
    console.log('privacy layer', layer)
    const bLocalDataSource = get(layer, 'localDataSource', false)

    if (bLocalDataSource) {
      PoziNotifications()
        .privacy(layer)
        .then(function (msg) {
          console.log(msg)
        })
        .catch(function (err) {
          console.error(err)
        })
    }
  }

  PoziUtils.turnLayerOn(titleid)

  // console.debug('Show linked layers from select layer event?', layer.titleid, layer.linkedLayers)

  let linkedLayers
  if (layer.linkedLayers) {
    linkedLayers = layer.linkedLayers || []
    PoziUtils.linkedLayersToggle(linkedLayers, true)
  }

  HistoryUpdate()

  // if the selected layer is in the levels group
  if (layer.groupid === 'levels') {
    // set the current level to layer
    setCurrentLevel(layer)

    // NOTE. this is a lazy algorithm and only applies the updated filter to
    // _visible_ layers. This should be faster than doing all layers, but
    // requires that a layer also applies the filter when its visibility changes.
    applyAutoFilterToVisibleLayers(layer)
  }

  const currentLevelProp = get(layer, 'autoFilterOnLevel.prop', null)
  if (!isNil(currentLevelProp)) {
    const currentLevel = getCurrentLevel()
    console.log('currentLevel: ', currentLevel)
    if (!currentLevel) {
      // show an error in console, but keep on working
      console.error('Error: Trying to apply the autoFilterOnLevel prop, but ' +
        ' the currentLevel is null.')
    } else {
      applyAutoFilterOnLevel(layer, currentLevel)
    }
  }

  // layer.selected = true

  // dispatch triggers constructor (new object)... TODO: Pass loaded data to initialise objects
  ModelUpdateLayer(layer)
  // window.store.dispatch(setLayerSelected(layer))
}
